const categories: {
  [key: string]:
    | {
        name: string
        slug: string
        primaryColor: string
        secondaryColor: string
        isFeatured: boolean
      }
    | undefined
} = {
  'Content Strategy': {
    name: 'Content Strategy',
    slug: 'content-strategy',
    primaryColor: '#CC9700',
    secondaryColor: '#FBF9F4',
    isFeatured: true
  },
  'Content Operations': {
    name: 'Content Operations',
    slug: 'content-operations',
    primaryColor: '#CC9700',
    secondaryColor: '#FBF9F4',
    isFeatured: true
  },
  'Content Analytics': {
    name: 'Content Analytics',
    slug: 'content-analytics',
    primaryColor: '#CC9700',
    secondaryColor: '#FBF9F4',
    isFeatured: true
  },
  'Demand Generation': {
    name: 'Demand Generation',
    slug: 'demand-generation',
    primaryColor: '#CC9700',
    secondaryColor: '#FBF9F4',
    isFeatured: true
  },
  'Organic Marketing': {
    name: 'Organic Marketing',
    slug: 'organic-marketing',
    primaryColor: '#CC9700',
    secondaryColor: '#FBF9F4',
    isFeatured: true
  },
  'Generative AI': {
    name: 'Generative AI',
    slug: 'generative-ai',
    primaryColor: '#CC9700',
    secondaryColor: '#FBF9F4',
    isFeatured: true
  },
  'Video Marketing': {
    name: 'Video Marketing',
    slug: 'video-marketing',
    primaryColor: '#CC9700',
    secondaryColor: '#FBF9F4',
    isFeatured: true
  },
  'Data and Studies': {
    name: 'Data and Studies',
    slug: 'data-and-studies',
    primaryColor: '#CC9700',
    secondaryColor: '#FBF9F4',
    isFeatured: true
  },
  Product: {
    name: 'Product',
    slug: 'product',
    primaryColor: '#CC9700',
    secondaryColor: '#FBF9F4',
    isFeatured: true
  }
}

// category pages which has separate page rather than having `/blog/category/{slug}`
export const STANDALONE_CATEGORY_PAGES: string[] = ['samples', 'pepper-shots']

export default categories
